/* jshint esversion: 8 */
define([
  "computeResource/collections/collection"
], function (
  Collection
) {

  class CloudNetworkCollection extends Collection {

    constructor (args) {
      super(args);
    }

  }

  return CloudNetworkCollection;
});
